var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSysCpanelFolder = function SvgSysCpanelFolder(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0652 6.3L10.6739 3H2.19565C1.2588 3 0.5 3.73837 0.5 4.65V32.7C0.5 34.5224 2.01846 36 3.8913 36H36.1087C37.9815 36 39.5 34.5224 39.5 32.7V9.6C39.5 7.77758 37.9815 6.3 36.1087 6.3H14.0652Z",
    fill: "url(#paint0_linear_8283_57719)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 11H0.5V4.6C0.5 3.716 1.2588 3 2.19565 3H10.6739L14.0652 6.2H36.1087C37.9815 6.2 39.5 7.6328 39.5 9.4V11Z",
    fill: "#CE26A1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 11H1.5C1.5 8.68256 1.5014 7.12035 1.50107 5.00073C1.50098 4.44829 1.94875 4 2.50119 4H10.5L14 7.25L35.9949 7.20511C37.3776 7.20229 38.5 8.3228 38.5 9.7055C38.5 10.3753 38.5 10.8808 38.5 11Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 11H0.5V8.1C0.5 7.216 1.2588 6.5 2.19565 6.5H10.6739L14.0652 9.7H39.5C39.5 10.5 39.5 10.5 39.5 11Z",
    fill: "#CE26A1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 16.5L15.5 18.5V21.5C15.5 24.275 17.42 26.87 20 27.5C22.58 26.87 24.5 24.275 24.5 21.5V18.5L20 16.5ZM20 18.45C20.2967 18.45 20.5867 18.538 20.8334 18.7028C21.08 18.8676 21.2723 19.1019 21.3858 19.376C21.4994 19.6501 21.5291 19.9517 21.4712 20.2426C21.4133 20.5336 21.2704 20.8009 21.0607 21.0107C20.8509 21.2204 20.5836 21.3633 20.2926 21.4212C20.0017 21.4791 19.7001 21.4494 19.426 21.3358C19.1519 21.2223 18.9176 21.03 18.7528 20.7834C18.588 20.5367 18.5 20.2467 18.5 19.95C18.5 19.5522 18.658 19.1706 18.9393 18.8893C19.2206 18.608 19.6022 18.45 20 18.45ZM20 22.4C21 22.4 23 22.945 23 23.94C22.6716 24.4351 22.2258 24.8412 21.7024 25.1221C21.1789 25.403 20.5941 25.55 20 25.55C19.4059 25.55 18.8211 25.403 18.2976 25.1221C17.7742 24.8412 17.3284 24.4351 17 23.94C17 22.945 19 22.4 20 22.4Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8283_57719",
    x1: 0.955,
    y1: 5.508,
    x2: 40.0775,
    y2: 7.59731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE2DA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.930222,
    stopColor: "#A3129E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC0792"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSysCpanelFolder);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "sys-cpanel-folder.4702f3eec9627a11555e72827688e288.svg";